import { useEffect } from 'react';

export function Analytics() {
  const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!GA_ID) return;

    // Load gtag script
    const script1 = document.createElement('script');
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script1.async = true;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.id = 'gtag-init';
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}', {
        page_path: window.location.pathname,
        cookie_domain: window.location.hostname,
        cookie_flags: 'SameSite=None;Secure'
      });
    `;
    document.head.appendChild(script2);

    return () => {
      // Cleanup on unmount
      const existingScript1 = document.querySelector(
        `script[src*="googletagmanager.com/gtag/js"]`,
      );
      const existingScript2 = document.getElementById('gtag-init');
      if (existingScript1) existingScript1.remove();
      if (existingScript2) existingScript2.remove();
    };
  }, [GA_ID]);

  return null;
}
